import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import { Button, Grid2 } from "@mui/material";
import DatePickerRange from "components/common/DatePickerRange";
import { assertObject } from "core/validation";
import React from "react";

function Form({ params, loadFilms }) {
    const [dateInterval, setDateInterval] = React.useState({
        dateStart: params.dateStart,
        dateEnd: params.dateEnd,
    });
    function handleChangeInterval(interval) {
        if (assertObject(interval)) {
            const key = Object.keys(interval)[0];
            const _newInterval = { ...dateInterval, [key]: interval[key] };
            setDateInterval(_newInterval);
            loadFilms(_newInterval);
        }
    }

    function handleClickSearch() {
        loadFilms(dateInterval);
    }

    return (
        (<Grid2 container spancing={2} style={{ paddingTop: 10 }}>
            <Grid2
                size={{
                    xs: 8,
                    md: 5
                }}>
                <DatePickerRange
                    noLabel
                    gridItemProps={{
                        xs: 6,
                        md: 5,
                    }}
                    customLabel={"Date Entered"}
                    fieldName="date"
                    start={dateInterval.dateStart}
                    end={dateInterval.dateEnd}
                    onChange={handleChangeInterval}
                    startSuffix={"Start"}
                    labelStart={""}
                    labelEnd={null}
                    endSuffix={"End"}
                />
            </Grid2>
            <Grid2
                style={{ textAlign: "right" }}
                size={{
                    xs: 4,
                    md: 7
                }}>
                <Button
                    onClick={handleClickSearch}
                    startIcon={<RefreshOutlinedIcon color={"secondary"} />}
                    variant={"outlined"}
                    style={{ marginTop: 25 }}
                >
                    Refresh
                </Button>
            </Grid2>
        </Grid2>)
    );
}

export default Form;
